import { Fragment, type HTMLAttributes } from 'react';

import { cn } from '@virginexperiencedays/tailwind';

// ui
import type { Regions } from '../../pages/product/Locations';

import { formatLocationString } from '../../utils/formatLocationString';

type Props = {
  regions: Regions;
  activeRegion: string;
  viewAsList: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const LocationsList = ({ regions, activeRegion, viewAsList, ...rest }: Props) => {
  const regionLocations = Object.values(regions);

  if (!regionLocations?.length) return null;

  return (
    <div {...rest}>
      {regionLocations?.map((locations) => {
        if (!Array.isArray(locations) || !locations.length) return null;

        const uniqueLocations = [];
        locations.forEach((location) => {
          if (!uniqueLocations.some((uniqueLocation) => uniqueLocation.name === location.name)) {
            uniqueLocations.push(location);
          }
        });
        if (!uniqueLocations?.length) return null;

        const region = uniqueLocations[0]?.region;
        if (!region) return null;

        const isActive = viewAsList && activeRegion === region;

        return (
          <Fragment key={region}>
            <h3 className="sr-only">{region}</h3>
            <ul
              className={cn(
                'm-0 flex max-h-0 list-none flex-row flex-wrap gap-x-1 overflow-hidden p-0 md:pr-[15%]',
                isActive ? 'max-h-[unset]' : null
              )}
            >
              {uniqueLocations.map(({ name }) => (
                <li
                  key={name}
                  className={cn(
                    "text-sm after:pl-1 after:content-['|'] last-of-type:after:p-0 last-of-type:after:content-['']"
                  )}
                >
                  {formatLocationString(name)}
                </li>
              ))}
            </ul>
          </Fragment>
        );
      })}
    </div>
  );
};
